import React, { useEffect, useState } from 'react';
import { Link, useParams } from "react-router-dom";
import './styles/Company.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faTelegram } from '@fortawesome/free-brands-svg-icons';
import firebase, { firebaseAnalytics }  from './components/Firebase';
import { faEnvelope, faGlobe, faMapMarked, faShareAlt, faTimesCircle, faCalendar, faSortNumericDownAlt, faLink } from '@fortawesome/free-solid-svg-icons';
import { Button, Modal, ModalBody } from 'react-bootstrap';
import Carousel from 'react-elastic-carousel';
import { Spinner } from 'react-bootstrap';
import Recensione from './components/Recensione';
import { useHistory } from 'react-router';
import GoogleMap from './components/GoogleMap';
import {
    EmailIcon,
    EmailShareButton,
    FacebookIcon,
    FacebookMessengerIcon,
    FacebookMessengerShareButton,
    FacebookShareButton,
    TelegramIcon,
    TelegramShareButton,
    TwitterIcon,
    TwitterShareButton,
    WhatsappIcon,
    WhatsappShareButton,
  } from "react-share";

const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 550, itemsToShow: 1 },
    { width: 768, itemsToShow: 2, itemsToScroll: 2 },
    { width: 1200, itemsToShow: 3, itemsToScroll: 3 }
];

export function Company() {
    const [products, setProducts] = useState([]);
    const [company, setCompany] = useState([]);
    const [order, setOrder] = useState("voto");
    const [loading, setLoading] = useState(true);
    const [show, setShow] = useState(false);
    let { id } = useParams();
    let history = useHistory();
    let url = window.location.href
 
    useEffect(() => {
        window.scrollTo({
            top: 350,
            left: 0,
            behavior: 'smooth'
          });
        firebaseAnalytics.logEvent("company_visited");
        firebaseAnalytics.setCurrentScreen("company_page")
        firebase.firestore().collection('aziende').doc(id).get().then(response => {
            setCompany(response.data())
        });
        firebase.firestore().collection('recensioni').where("marca", "==", id).get().then(response => {
            const prodotti = [];
            response.forEach(prodotto => prodotti.push(prodotto.data()));
            setProducts(
                prodotti.sort(function compareNumbers(a, b) {
                    var num = (
                            (b.tipo === "Erba"?
                            ((b.aspetto + b.fumata + b.odore + b.svapata)/4)
                            :
                            ((b.aspetto + b.fumata )/2))
                            - 
                            (a.tipo === "Erba"?
                            ((a.aspetto + a.fumata + a.odore + a.svapata)/4)
                            :
                            ((a.aspetto + a.fumata ) /2))
                        )
                    return num;
                })
                );
        });
        setLoading(false);
    }, []);

    const onHideModal = () => {
        setShow(false);
    }

    const changeOrder = (order) => {
        switch( order ) {
            case "data": 
                setProducts(    
                    products.sort(function compareNumbers(a, b) {
                        return (b.data - a.data );
                    })
                );
            break;
            case "voto":
                setProducts(
                    products.sort(function compareNumbers(a, b) {
                        var num = (
                                (b.tipo === "Erba"?
                                ((b.aspetto + b.fumata + b.odore + b.svapata)/4)
                                :
                                ((b.aspetto + b.fumata )/2))
                                - 
                                (a.tipo === "Erba"?
                                ((a.aspetto + a.fumata + a.odore + a.svapata)/4)
                                :
                                ((a.aspetto + a.fumata ) /2))
                            )
                        return num;
                    })
                );
            break;
        }
    }

    return (
        <>
        <div className="companyBody" >
            <div style={{ color:"lightgrey"}}>
                <FontAwesomeIcon icon={faTimesCircle} style={{ cursor: "pointer"}} onClick={() => history.push("/aziende") }/> 
                <text style={{ marginLeft: "10px", cursor: "pointer"}} onClick={() => history.push("/aziende") } >
                    Torna alle aziende
                </text>  
            </div> 
        <p className="modal--voti azienda--modal">
            </p> 
            
                <div className="company_Body-card" >
                    { loading === true ? <Spinner animation="grow"/> :
                        (company === undefined ? 
                        <>
                            <br />
                            <h3 style={{ alignSelf: "center",color: 'white' }}>Pagina non trovata.</h3>
                            <br /> 
                        </>
                        :
                        (<>
                            {loading && <h2 style={{ color: 'white' }}><Spinner animation="grow" /></h2>}
                            
                            {/*NOME E LOGO AZIENDA*/}
                            <div className="nameCompany col-50 padding-20 tito-title" >
                                <div className="company__img">
                                    <img src={company.logo} alt="" style={{maxHeight: "150px", borderRadius: "10px"}} />
                                </div>
                                <div style={{alignSelf: "center", marginInline: "1%"}}>
                                    <h2 >{company.nome} </h2>
                                </div>
                            </div>
                            <br />
                            
                            {/*SU DI NOI*/}
                            <div >
                                <div className="grid-company">
                                    <div className="col-65 col-50s padding-20">
                                        <div className="brb description padding-20 tito">
                                            <h2 style={{color: "white"}} >Su di noi</h2>
                                            {company.descrizione === "" ? 
                                                <p>Nessuna descrizione disponibile.</p> : 
                                                <p>{company.descrizione}</p>
                                            }
                                        </div>
                                        <br />
                                        <br />
                                        
                                        {/*RECENSIONI*/}
                                        <div className="brb" style={{margin: 0, flexFlow: "column", borderRadius: "10px"}}>
                                            <div className="carusel__company padding-20">
                                                <h2 style={{color: "white"}} >Recensioni</h2>
                                                    <text className='row' style={{fontSize: 15, justifyContent: "center"}}>ordina per: 
                                                        <a  style={{color: "white" , paddingBottom: "10px", paddingLeft: "10px"}} onClick={() => {
                                                            if(order === "voto"){
                                                                changeOrder("data"); 
                                                                setOrder("data")}
                                                            else if (order === "data"){
                                                                changeOrder("voto");
                                                                setOrder("voto")}}}>
                                                            <div style={{cursor: "pointer"}}>
                                                                {order} 
                                                                {order==="data"?
                                                                <FontAwesomeIcon icon={faCalendar} />:
                                                                <FontAwesomeIcon icon={faSortNumericDownAlt}/>}
                                                            </div>
                                                        </a>  
                                                    </text>
                                                <Carousel breakPoints={breakPoints} showArrows={true}>
                                                    {products.length === 0 ? 
                                                        <text>Nessuna recensione disponibile.</text> :
                                                        products.map(review => {
                                                            return <Recensione review={review} />
                                                        })
                                                    }
                                                </Carousel>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    {/*CONTATTI*/}
                                    <div className="odina-company col-30 col-50s padding-20 tito">
                                        <div className="contattiCompany">
                                            <div className="row--company">
                                                <div className='social-container'>
                                                    <div className="social inriga" style={{color: "white", cursor:"pointer"}} onClick={() => setShow(true)}>
                                                        Condividi la pagina!
                                                        <FontAwesomeIcon icon={faShareAlt} size='2x' />
                                                    </div>
                                                </div>
                                            </div>
                                            <br/>
                                            <h2 style={{color: "white"}} >Contatti</h2>
                                            {/*sito*/}
                                            <div className='social-container'> 
                                                {company.sito === undefined || company.sito === "" ? 
                                                    <p className="facebook social inriga">
                                                        <FontAwesomeIcon icon={faGlobe} size='2x' />
                                                        <p>Sito non disponibile.</p> 
                                                    </p>
                                                : 
                                                    <a className="facebook social inriga" href={company.sito} target="_blank" onClick={() => firebaseAnalytics.logEvent("button_sito_pressed")}>
                                                        <FontAwesomeIcon icon={faGlobe} size='2x' />
                                                        <p>{company.sito.replace('http:','').replace('https:','').replaceAll("/","").length > 25? 
                                                            company.sito.replace('http:','').replace('https:','').replaceAll("/","").substring(0,24)+"[...]"
                                                            :
                                                            company.sito.replace('http:','').replace('https:','').replaceAll("/","")
                                                            }</p>
                                                    </a>
                                                }
                                            </div>
                                            {/*instagram*/}
                                            <div className='social-container'> 
                                                {company.instagram === undefined || company.instagram === "" ? 
                                                    <a className="instagram social inriga">
                                                        <FontAwesomeIcon icon={faInstagram} size='2x' />
                                                        <p>Instagram non disponibile.</p>
                                                    </a>
                                                : 
                                                    <a className="instagram social inriga" href={company.instagram} target="_blank" onClick={() => firebaseAnalytics.logEvent("button_instagram_pressed")}>
                                                        <FontAwesomeIcon icon={faInstagram} size='2x' />
                                                        <p>@{company.instagram}</p>
                                                    </a>
                                                }
                                            </div>
                                            {/*telegram*/}
                                            <div className='social-container'> 
                                                {company.telegram === undefined || company.telegram === "" ? 
                                                    <p className="telegram social inriga">
                                                        <FontAwesomeIcon icon={faTelegram} size='2x' />
                                                        <p>Telegram non disponibile.</p>
                                                    </p>
                                                : 
                                                    <a className="telegram social inriga" href={company.telegram} target="_blank" onClick={() => firebaseAnalytics.logEvent("button_telegram_pressed")}>
                                                        <FontAwesomeIcon icon={faTelegram} size='2x' />
                                                        <p>{company.telegram}</p>
                                                    </a>
                                                }
                                            </div>
                                            {/*email*/}
                                            <div className='social-container'> 
                                                {company.email === undefined || company.email === "" ? 
                                                    <p className="email social inriga">
                                                        <FontAwesomeIcon icon={faEnvelope} size='2x' />
                                                        <p>Email non disponibile.</p> 
                                                    </p> 
                                                : 
                                                <a className="email social inriga" href={"mailto:"+company.email} onClick={() => firebaseAnalytics.logEvent("button_email_pressed")}>
                                                    <FontAwesomeIcon icon={faEnvelope} size='2x' />
                                                    <p>{company.email}</p>
                                                </a>
                                                }
                                            </div>
                                            {/*indirizzo*/}
                                            <div className='social-container'>
                                                {!loading && company.mappa !== undefined && company.mappa !== ""? (
                                                    <a className="social inriga" style={{color: "yellow"}} href={"https://www.google.com/maps/search/?api=1&query="+company.mappa.latitude+"%2C"+company.mappa.longitude} target="_blank">
                                                        <FontAwesomeIcon icon={faMapMarked} size='2x' /> Indirizzo
                                                    </a>)
                                                : (
                                                    <p className="social inriga" style={{color: "yellow"}}>
                                                        <FontAwesomeIcon icon={faMapMarked} size='2x' /> Indirizzo non disponibile.
                                                    </p>)
                                                }
                                            </div>
                                        </div>
                                        <div className="evntuale__maps col-50s">
                                            {!loading && company.mappa !== undefined ? 
                                                <GoogleMap map= {company.mappa}/>
                                                : null
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>)
                        )
                    }
                </div>
        </div>
        <Modal size="md" show={show} centered onHide={() => onHideModal()} >
            <ModalBody>
                <div className="row" style={{justifyContent: "space-evenly"}}>
                    <div style={{color: 'white', alignSelf: "center", cursor: "pointer"}} onClick={() => {navigator.clipboard.writeText(url); onHideModal()}}>
                            <FontAwesomeIcon icon={faLink} size="2x" />
                            <text style={{verticalAlign: "super", marginLeft: "2px"}}>Link</text>
                    </div>
                    <div style={{color: 'white'}}>
                        <EmailShareButton url= {url}>
                            <EmailIcon round={true} size={40} />
                            Email
                        </EmailShareButton>
                    </div>
                    <div style={{color: 'white'}}>
                        <WhatsappShareButton url= {url} >
                            <WhatsappIcon round={true} size={40} />
                            Whatsapp
                        </WhatsappShareButton>
                    </div>
                    <div style={{color: 'white'}}>
                        <TelegramShareButton url= {url} >
                            <TelegramIcon round={true} size={40} />
                            Telegram
                        </TelegramShareButton>
                    </div>
                    <div style={{color: 'white'}}>
                        <FacebookShareButton url= {url}>
                            <FacebookIcon round={true} size={40}/>
                            Facebook
                        </FacebookShareButton>
                    </div>
                    <div style={{color: 'white'}}>
                        <TwitterShareButton url= {url} >
                            <TwitterIcon round={true} size={40}/>
                            Twitter
                        </TwitterShareButton>
                    </div>
                    <div style={{color: 'white'}}>
                        <FacebookMessengerShareButton url= {url} >
                            <FacebookMessengerIcon round={true} size={40}/>
                            Messenger
                        </FacebookMessengerShareButton>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    </>
    );
}